module.exports = __webpack_public_path__ + "static/media/AoA_CloseUp_11.f47f7be5.jpg";